<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu luân chuyển thiết bị</h1>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              v-model.trim="filters.codeVoucher"
              type="text"
              placeholder="Mã phiếu"
              style="border-radius: 4px"
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="filters.codeContract"
              type="text"
              placeholder="Mã hợp đồng"
              style="border-radius: 4px"
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="filters.sender"
              type="text"
              placeholder="Đối tượng chuyển"
              style="border-radius: 4px"
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="filters.recipient"
              type="text"
              placeholder="Đối tượng nhận"
              style="border-radius: 4px"
            />
          </div>

          <!-- <div class="form-group">
            <Select2
              v-model="filters.sender"
              :settings="settingSearch"
              placeholder=""
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.recipient"
              :settings="settingSearch"
              placeholder=""
            ></Select2>
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.appendixCreator"
              :settings="settingSearch"
              placeholder="Người tạo"
            ></Select2>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate('DD/MM/YYYY') }} -
                  {{ picker.endDate | formatDate('DD/MM/YYYY') }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo PL
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="Config.getSearch(listStatus)"
              placeholder="Trạng thái phiếu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeOfAppendix"
              :options="Config.getSearch(Config.typeAppendix)"
              placeholder="Loại phụ lục"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.reason"
              :options="Config.getSearch(Config.listReasonAppendix)"
              placeholder="Lý do"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>

      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="">
              <div class="d-flex flex-row">
                <div class="box-header list_total">
                  <TotalCountCheck
                    :titleTotal="'Tổng số phiếu:'"
                    :totals="totalCount"
                    :data="totals"
                  ></TotalCountCheck>
                </div>
              </div>
              <b-table
                :busy.sync="loading"
                head-variant="light"
                sticky-header
                hover
                responsive
                :items="dataTable"
                :fields="fieldsTable"
                selectable
                show-empty
                select-mode="single"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #cell(index)="{ index }">
                  <span class="text-center">
                    {{
                      pagination.page > 1
                        ? index + 1 + pagination.limit * (pagination.page - 1)
                        : index + 1
                    }}
                  </span>
                </template>
                <template #cell(contract)="{ item }">
                  <b-link target="_blank" :href="`/contract-detail-ecommerce/${item.contractId}`">{{
                    item.contractCode
                  }}</b-link>
                  <div>
                    <span class="text-muted text-secondary"> Loại phụ lục:</span>
                    <span>
                      {{ item.contractType | transformData(Config.typeAppendix) }}
                    </span>
                  </div>
                </template>
                <template #cell(code)="{ item }">
                  <b-link class="text-primary">{{ item.code }}</b-link>
                </template>

                <template #cell(sender)="{ item }">
                  <div>
                    <b class="text-secondary">Đối tượng: </b>
                    <span>
                      {{ getSenderTypeText(item.sender?.type) }}
                    </span>
                  </div>
                  <div>
                    <b class="text-secondary">Tên: </b>
                    <span>
                      {{ item.sender?.name }}
                    </span>
                  </div>
                  <div>
                    <b class="text-secondary">Email: </b>
                    <b-link :href="`mailto:${item.sender?.email}`" class="text-primary">
                      {{ maskSensitiveInfo(item.sender?.email || '') }}
                    </b-link>
                    <i
                      v-if="item.sender?.email"
                      @click="copyToClipboard(item.sender?.email || '')"
                      style="font-size: 16px; margin-left: 5px; color: gray; cursor: pointer"
                      class="bx bxs-copy"
                    ></i>
                  </div>
                </template>
                <template #cell(receiver)="{ item }">
                  <div>
                    <b class="text-secondary">Đối tượng: </b>
                    <span>
                      {{ getSenderTypeText(item.receiver?.type) }}
                    </span>
                  </div>
                  <div>
                    <b class="text-secondary">Tên: </b>
                    <span>
                      {{ item.receiver?.name }}
                    </span>
                  </div>
                  <div>
                    <b class="text-secondary">Email: </b>
                    <b-link :href="`mailto:${item.receiver?.email}`" class="text-primary">
                      {{ maskSensitiveInfo(item.receiver?.email || '') }}
                    </b-link>
                    <i
                      v-if="item.receiver?.email"
                      @click="copyToClipboard(item.receiver?.email || '')"
                      style="font-size: 16px; margin-left: 5px; color: gray; cursor: pointer"
                      class="bx bxs-copy"
                    ></i>
                  </div>
                </template>
                <template #cell(createdByName)="{ item }">
                  <div v-if="item?.createByName">
                    <b class="text-secondary">Tạo PL: </b>
                    <span> {{ item?.createByName }}</span>
                  </div>
                  <div v-if="item?.approveByName">
                    <b class="text-secondary">Duyệt: </b>
                    <span> {{ item?.approveByName }}</span>
                  </div>
                  <div v-if="item?.cancelByName">
                    <b class="text-secondary">Từ chối: </b>
                    <span> {{ item?.cancelByName }}</span>
                  </div>
                </template>

                <template #cell(datetime)="{ item }">
                  <div v-if="item?.dateCreateContract">
                    <b class="text-secondary">Tạo PL: </b>
                    <span> {{ item?.dateCreateContract | formatDate('HH:mm DD/MM/YYYY') }}</span>
                  </div>
                  <div v-if="item?.dateApprove">
                    <b class="text-secondary">Duyệt: </b>
                    <span> {{ item?.dateApprove | formatDate('HH:mm DD/MM/YYYY') }}</span>
                  </div>
                  <div v-if="item?.dateCancel">
                    <b class="text-secondary">Từ chối: </b>
                    <span> {{ item?.dateCancel | formatDate('HH:mm DD/MM/YYYY') }}</span>
                  </div>
                </template>
                <template #cell(status)="{ item }">
                  <div class="">
                    <span :class="`badge ${getStatusObj(item?.status)?.bgColor}`">
                      {{ getStatusObj(item?.status)?.text }}
                    </span>
                  </div>
                </template>
                <template #cell(actions)="{ item }">
                  <div class="text-center">
                    <b-link
                      :href="`/customer-support/order-contract/${item.id}`"
                      target="_blank"
                      style="color: #0056f6"
                      size="sm"
                    >
                      <img
                        src="@/assets/img/circle-three-dots.svg"
                        alt="Circle with Three Dots"
                        style="width: 15px; height: 15px"
                      />
                      Chi tiết
                    </b-link>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end pagination-bottom">
          <b-form-group class="mb-0" style="padding: 17px">
            <b-form-select
              v-model="pagination.limit"
              :options="pageOptions"
              @change="onItemsPerPageChange"
            ></b-form-select>
          </b-form-group>
          <b-pagination
            v-model="pagination.page"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="pagination.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { List } from '@/services/customer-support/order-contract'
  import { SearchStaff } from '@/services/customer-support/staff'
  import TotalCountCheck from '@/components/cskh/Counts.vue'
  import { CommonService } from '@/services/common.service'
  import { showMess } from '@/config/utils'
  import DateRangePicker from 'vue2-daterange-picker'
  import { Search } from '@/services/customer-support/account'
  // import { MaRole } from '@/constant/customerSupport'
  // import { StaffService } from '@/services/staff.service'
  // import StaffAssign from '@/components/cskh/StaffAssign.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    {
      key: 'code',
      label: 'Mã phiếu yêu cầu',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'contract',
      label: 'Mã hợp đồng/Phụ lục',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'sender',
      label: 'Đối tượng chuyển',
      thStyle: 'min-width: 120px',
    },
    {
      key: 'receiver',
      label: 'Đối tượng nhận',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'datetime',
      label: 'Ngày',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'createdByName',
      label: 'Nhân viên',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'status',
      label: 'Trạng thái',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'actions',
      label: 'Thao tác',
      fixIndex: 999,
      class: 'text-center',
      thStyle: 'min-width: 80px',
    },
  ]

  const typeMapping = {
    EMPLOYEE: 'Nhân viên',
    MERCHANT: 'Merchant',
  }

  export default {
    components: { TotalCountCheck, DateRangePicker },
    data() {
      return {
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        Config,
        fieldsTable,
        typeMapping,
        showLoading: false,
        totalCount: 0,
        // userId: JSON.parse(localStorage.getItem('userData')).userId,
        totals: [],
        listStatus: [
          { id: 'NEW', text: 'Mới tạo', bgColor: 'badge-primary' },
          { id: 'COMPLETED', text: 'Hoàn thành', bgColor: 'badge-success' },
          { id: 'CANCEL', text: 'Từ chối', bgColor: 'badge-danger' },
        ],
        listCountMapping: {
          countCancel: {
            text: 'Từ chối',
            bgColor: 'text-danger',
          },
          countDone: {
            text: 'Hoàn thành',
            bgColor: 'text-success',
          },
          countNew: {
            text: 'Tạo mới',
            bgColor: 'text-primary',
          },
        },
        filters: {
          codeVoucher: '',
          codeContract: '',
          sender: '',
          recipient: '',
          createDateFrom: null,
          createDateTo: null,
          appendixCreator: '',
          status: '',
          typeOfAppendix: '',
          reason: '',
        },
        localeData: Config.localeData,
        loading: false,
        dataStaff: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        settingSearch: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const queryString = [
                `{textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}'''`,
              ]
              if (this.tLoadAccount) {
                clearTimeout(this.tLoadAccount)
              }
              this.tLoadAccount = setTimeout(() => {
                // Tạo mảng chứa cả 2 promise của API calls
                Promise.all([
                  // Gọi API thứ 1
                  Search({
                    showFields: ['id', 'accountName', 'email', 'businessRegistrationNumber'],
                    limit: 20,
                    page: 1,
                    queryString: queryString.join(' AND '),
                    sort: {
                      direction: 'ASC',
                      properties: ['accountName'],
                    },
                  }),
                  // Gọi API thứ 2
                  SearchStaff({
                    keyWord: txtSearch,
                    limit: 20,
                    page: 1,
                  }),
                ])
                  .then(([res1, res2]) => {
                    // Kết hợp kết quả từ cả 2 API
                    const combinedResults = [
                      ...(res1.data?.listData.map(item => ({
                        id: item?.id,
                        text: item?.accountName ?? item?.email,
                      })) || []),
                      ...(res2.data?.map(item => ({
                        id: item?.id,
                        text: item?.name ?? item?.userName,
                      })) || []),
                    ]

                    success({
                      results: combinedResults,
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        pagination: {
          sortField: 'created_date',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        dataTable: [],
      }
    },
    async created() {
      await this.configSystem()
      await this.buildQuery()
    },

    computed: {
      getStatusObj() {
        return status => {
          const mapStatus = this.listStatus.reduce((acc, cur) => {
            acc[cur.id] = cur
            return acc
          }, {})
          return mapStatus[status] || { text: status || '', bgColor: '' }
        }
      },

      getSenderTypeText() {
        return type => {
          return typeMapping[type] || type
        }
      },
    },

    methods: {
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showMess(
              this,
              'Success',
              'Sao chép thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
          .catch(err => {
            console.error('Lỗi khi sao chép: ', err)
            showMess(
              this,
              'Error',
              'Lỗi khi sao chép: ' + err,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
      },
      maskSensitiveInfo(input) {
        if (input.includes('@')) {
          return input.replace(/(.{2}).+(@.+)/, '$1****$2')
        } else if (/^(\d{10})$/.test(input) || /(\d{2,3})\d{4}(\d{3,4})/.test(input)) {
          return input.replace(/(\d{2,3})\d{4}(\d{3,4})/, '$1****$2')
        } else {
          return input.replace(/(.{3}).+(.{3})/, '$1****$2')
        }
      },
      transformDate() {
        this.filters.createDateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.createDateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      transformCount(data) {
        return data.map(item => ({
          count: item.count,
          ...this.listStatus[item.status],
        }))
      },
      async clearSearch() {
        this.filters = {
          codeVoucher: '',
          codeContract: '',
          sender: '',
          recipient: '',
          createDateFrom: null,
          createDateTo: null,
          appendixCreator: '',
          status: '',
          typeOfAppendix: '',
          reason: '',
        }
        this.pagination = {
          // sortField: 'created_date',
          // sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }

        await this.buildQuery()
      },
      async buildQuery() {
        const conditionsMap = {}

        const listKeyParams = [
          'codeVoucher',
          'codeContract',
          'sender',
          'recipient',
          'createDateFrom',
          'createDateTo',
          'appendixCreator',
          'status',
          'typeOfAppendix',
          'reason',
        ]

        listKeyParams.forEach(key => {
          // Kiểm tra giá trị không phải là "0" hoặc 0
          if (this.filters[key] && this.filters[key] !== '0' && this.filters[key] !== 0) {
            conditionsMap[key] = this.filters[key]
          }
        })

        if (this.dateRange?.startDate && this.dateRange?.endDate) {
          this.filters.createDateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
          this.filters.createDateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
        }

        // Thêm giá trị thời gian vào conditionsMap
        conditionsMap.createDateFrom = this.filters.createDateFrom
        conditionsMap.createDateTo = this.filters.createDateTo
        await this.loadData(conditionsMap)
      },

      async loadData(conditionsMap = {}) {
        try {
          this.loading = true
          const searchQuery = {
            countStatus: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            // queryString: this.pagination.queryString,
            ...conditionsMap,
            // sortResultList: [
            //   {
            //     direction: this.pagination.sortType,
            //     field: this.pagination.sortField
            //   }
            // ]
          }
          const res = await List(searchQuery)
          if (res.code === 1000) {
            const { data, count, limit, page, ...dataCount } = res.data || {}
            this.dataTable = data || []
            this.pagination.total = count || 0
            this.totalCount = count ?? 0

            this.totals = Object.entries(dataCount).map(item => {
              const { text, bgColor } = this.listCountMapping[item[0]]
              return { status: text, status_class: bgColor, count: item[1] }
            })
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loading = false
        }
      },

      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      onItemsPerPageChange() {
        this.pagination.page = 1
        this.buildQuery()
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
            }
          })
          .catch(error => console.error(error))
      },

      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        await this.buildQuery()
      },
    },
  }
</script>

<style lang="scss" scoped></style>
